export default __webpack_public_path__ + "images/Three_Vessel_View_dark.26560e34feadc2bcd2e92a4028355856.png";